export const config = {
    appType: import.meta.env.VITE_PROJECT_TYPE || 'default',
    appName: import.meta.env.VITE_APP_NAME || 'Slope Dashboard',
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api',
    env: import.meta.env.VITE_ENV || 'development',
    debug: import.meta.env.VITE_DEBUG === 'true',
    GOOGLE_MAP_API_KEY: import.meta.env.VITE_GOOGLE_MAP_API_KEY,
};
